import React, { useEffect, useId, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import backend from '../../api/server';

export const SubsidiaryActionModal = ({
    show,
    onHide,
    isLoading,
    refresh,
    isCreation = true,
    subsidiary = null,
}) => {
    const [subName, setSubName] = useState(subsidiary?.name || '');
    const [state, setState] = useState({
        isProcessing: false,
        isError: false,
        errorMessage: '',
    });
    const id = useId();

    useEffect(() => {
        if (show) {
            setState({
                isProcessing: false,
                isError: false,
                errorMessage: '',
            });
            setSubName(subsidiary?.name || '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const handleSubmit = async () => {
        if (!subName || subName.length < 2) return;

        setState((prevState) => ({
            ...prevState,
            isProcessing: true,
            isError: false,
            errorMessage: '',
        }));

        try {
            const payload = {
                name: subName,
                enabled: true,
            };

            isCreation
                ? await backend.post('subsidiaries', payload)
                : await backend.put(`subsidiaries/${subsidiary.id}`, payload);

            onHide?.();
            refresh?.();
        } catch (error) {
            setState((prevState) => ({
                ...prevState,
                isError: true,
                errorMessage: error.response
                    ? error.response.data?.msg
                    : error.message,
            }));
        } finally {
            setState((prevState) => ({
                ...prevState,
                isProcessing: false,
            }));
            setSubName('');
        }
    };
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {isCreation ? 'Crear' : 'Actualizar'} Sucursal
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {state.isProcessing || isLoading ? (
                    <div className="overlay">
                        <Spinner animation="border" role="status">
                            <span className="sr-only"></span>
                        </Spinner>
                    </div>
                ) : state.isError ? (
                    <div>{state.errorMessage}</div>
                ) : (
                    <Form.Group>
                        <Form.Label htmlFor="name">Nombre</Form.Label>
                        <Form.Control
                            value={subName}
                            type="text"
                            id="name"
                            aria-describedby={id + '-name'}
                            placeholder="Sucursal CDMX..."
                            onChange={({ currentTarget }) =>
                                setSubName(currentTarget.value)
                            }
                        />
                        <Form.Text id={id + '-name'} muted>
                            Nota: La sucursal que se crea desde aquí, tambien
                            podrá visualizarse desde el panel admin y en el
                            proceso de pago con el texto generado
                            automáticamente de "Recoger en ...".
                        </Form.Text>
                    </Form.Group>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={state.isProcessing || isLoading}
                    style={{
                        backgroundColor: state.isProcessing
                            ? '#6c757d'
                            : '#007bff',
                    }}
                >
                    {state.isProcessing ? 'Procesando...' : 'Confirmar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
